import React, { PropTypes } from "react";
import BillingPeriodField from "../BillingPeriodField";

const dependentPersonCoveragesTerminationsForm = ({ billingPeriods }) => (
  <BillingPeriodField
    id="billingPeriodId"
    name="billingPeriodId"
    billingPeriods={billingPeriods}
  />
);

dependentPersonCoveragesTerminationsForm.propTypes = {
  billingPeriods: PropTypes.array.isRequired,
};

export default dependentPersonCoveragesTerminationsForm;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/dependentPersonCoveragesTerminations/dependentPersonCoveragesTerminationsForm.js